import React from 'react';
import Pagination from 'react-js-pagination';

const BlankCardsList = (props) => {
    const paginationStyles = {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        marginTop: '10px',
    }  
    
    const handlePageChange = (pageNumber) => {
        props.handlePageChange(pageNumber)
    }

    let rows = props.cards.map((card) => {
        return <tr>
            <td>{card.Futura_No}</td>
            <td>{card.Card_No}</td>
            <td>{card.created_at}</td>
        </tr>   
    })
    
    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Futura No.</th>
                        <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Card No.</th>
                        <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Created At</th>
                    </tr>
                </thead>
                <tbody>
                    {rows}
                    {rows.length === 0 &&
                        <tr>
                            <td colSpan="7">No results founds.</td>
                        </tr>
                    }
                </tbody>
            </table>
            {props.totalCards > 50 &&
                <div style={paginationStyles}>
                    <nav>
                        <Pagination
                            activePage={props.currentPage}
                            itemsCountPerPage={50}
                            totalItemsCount={props.totalCards}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            innerClass="pagination"
                        />
                    </nav>
                </div>
            }
        </div>
    );
}

export default BlankCardsList;